'use es6';

import invariant from 'react-utils/invariant';
import { createBrowserHistory, createLocation } from 'history';
import { getAppRoot } from './Urls';
var history = createBrowserHistory({
  basename: getAppRoot()
});
export var navigateTo = function navigateTo() {
  invariant(history, 'history not initialized');
  return history.push.apply(history, arguments);
};
export var replace = function replace() {
  invariant(history, 'history not initialized');
  return history.replace.apply(history, arguments);
};
export var getFullHref = function getFullHref(to) {
  var includeProtocol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  invariant(history, 'history not initialized');
  var _window$location = window.location,
      protocol = _window$location.protocol,
      hostname = _window$location.hostname;
  var location = typeof to === 'string' ? createLocation(to, null, null, history.location) : to;
  var href = history.createHref(location);
  return "" + (includeProtocol ? protocol + "//" : '') + hostname + href;
};
export default history;